export default {"src":"/_next/static/media/KomatsuLogo.dce64984.svg","height":68,"width":350,"blurWidth":0,"blurHeight":0};